import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const REACT_QUERY_TEST_CLIENT = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const ReactQueryTestClientProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <QueryClientProvider client={REACT_QUERY_TEST_CLIENT}>
      {children}
    </QueryClientProvider>
  );
};
